import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { sendAuthenticationCode} from './connectSocialAcc';
import LoadingScreen from '../../CommonComponents/LoadingScreen';
import authenticateUser from './websiteAuth';
import { useDispatch } from 'react-redux';
// Google / Facebook ka authorization code single-use hota hai. access_token set hote hi
// RoutesExtends LoginBasePage se BasePage pe switch karta hai aur ye component remount ho jata hai
// (dono route trees me /feeds/authCallback maujood hai), jisse wahi code dobara exchange hone chala
// jata hai aur oauth2.googleapis.com/token 400 (invalid_grant) de deta hai.
let processedCode = null;

const Authorization = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        var networkId = JSON.parse(localStorage.getItem("networkId"));
        var connectionType = localStorage.getItem("connectionType");
        const code = searchParams.get('code');
        const state = searchParams.get('state');

        if (code && processedCode === code) return;
        processedCode = code;

        // Booth flow: sirf code bhejna hai, koi exchange/redirect nahi.
        // Har browser (Safari me opener null ho sakta hai, purane browsers me BroadcastChannel nahi hota)
        // ke liye teeno raste try karte hain; alag channel/key taaki existing 'connect' listeners ko na mile.
        if(state && state.startsWith("booth_")){
            const payload = JSON.stringify({ type: 'booth', code, state });
            let boothChannel = null;
            try { window.opener?.postMessage(payload, '*'); } catch (e) {}
            try {
                if ('BroadcastChannel' in window) {
                    boothChannel = new BroadcastChannel('booth');
                    boothChannel.postMessage(payload);
                }
            } catch (e) {}
            try { localStorage.setItem('boothAuthCode', payload); } catch (e) {}
            setTimeout(() => {
                try { boothChannel?.close(); } catch (e) {}
                window.close();
            }, 1000);
            return;
        }

        if(state && state.includes("websiteSignupTB")){
            const signUpData = state.split('_');
            if(signUpData.length == 5){
                const [identifier, networkName, userToken, themeId, signUpPage] = signUpData;
                localStorage.removeItem('access_token');
                localStorage.setItem("referenceId", userToken);
                const referePageLink = atob(signUpPage);
                authenticateUser({code, referenceId: userToken, themeId, type: networkName, referePageLink, dispatch, history: navigate});
                return;
            }
        }
        
        sendAuthenticationCode(networkId, code, connectionType);

    }, [])

    return <LoadingScreen />
}
export default Authorization